import {
  UPGRADE_WALLET_FAILED,
  UPGRADE_WALLET_INVALID_REQUEST,
  UPGRADE_WALLET_SUCCESS,
  UPGRADE_WALLET_IN_REVIEW,
  RESET_UPGRADE_WALLET,
  NETWORK_ERROR_UPGRADE_WALLET,
  LOADING_WALLET,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  success: false,
  inReview: false,
  networkError: "",
  data: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_WALLET:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        success: false,
        inReview: false,
        networkError: "",
        data: {},
      };
    case UPGRADE_WALLET_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        failed: true,
        inReview: false,
        networkError: "",
        data: action.payload,
      };
    case UPGRADE_WALLET_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        inReview: false,
        failed: false,
        networkError: "",
        data: action.payload,
      };
    case UPGRADE_WALLET_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        inReview: false,
        success: true,
        invalidRequest: false,
        networkError: "",
        data: action.payload,
      };

    case UPGRADE_WALLET_IN_REVIEW:
      return {
        ...state,
        isLoading: false,
        failed: false,
        inReview: true,
        success: false,
        invalidRequest: false,
        networkError: "",
        data: action.payload,
      };

    case NETWORK_ERROR_UPGRADE_WALLET:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        invalidRequest: false,
        networkError: "Something went wrong..",
      };

    case RESET_UPGRADE_WALLET:
      return (state = initialState);

    default:
      return state;
  }
};
